$(document).on('turbolinks:load', function() {
  const selectedMatch = document.querySelector('.hotsite-schedule-match--selected');
  if (selectedMatch) {
    selectedMatch.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  $(document).on('show.bs.collapse', '.hotsite-schedule-round__collapse', function() {
    const collapseId = $(this).attr('id');
    const trigger = $(`[data-target="#${collapseId}"]`);
    const icon = trigger.find('.hotsite-schedule-round__chevron');
    icon.removeClass('mdi-chevron-right mdi-chevron-down').addClass('mdi-chevron-up');
  });

  $(document).on('hide.bs.collapse', '.hotsite-schedule-round__collapse', function() {
    const collapseId = $(this).attr('id');
    const trigger = $(`[data-target="#${collapseId}"]`);
    const isNextUp = trigger.closest('.hotsite-schedule-next-up').length > 0;
    const icon = trigger.find('.hotsite-schedule-round__chevron');
    icon.removeClass('mdi-chevron-up').addClass(isNextUp ? 'mdi-chevron-down' : 'mdi-chevron-right');
  });

  $(document).on('show.bs.collapse', '.hotsite-schedule-match__collapse', function() {
    const collapseId = $(this).attr('id');
    const trigger = $(`[data-target="#${collapseId}"]`);
    trigger.find('.hotsite-schedule-match__chevron')
      .removeClass('mdi-chevron-down')
      .addClass('mdi-chevron-up');
  });

  $(document).on('hide.bs.collapse', '.hotsite-schedule-match__collapse', function() {
    const collapseId = $(this).attr('id');
    const trigger = $(`[data-target="#${collapseId}"]`);
    trigger.find('.hotsite-schedule-match__chevron')
      .removeClass('mdi-chevron-up')
      .addClass('mdi-chevron-down');
  });
});

$(document).on('change', '.division-filter-select', function() {
  const $form = $(this).closest('form');

  $.ajax({
    url: $form.attr('action'),
    data: $form.serialize(),
    dataType: 'script'
  });
});
